import { render, staticRenderFns } from "./CertificatesCreate.vue?vue&type=template&id=c8d79f0e&"
import script from "./CertificatesCreate.vue?vue&type=script&lang=js&"
export * from "./CertificatesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports